import { Component, SimpleChanges, OnChanges, ChangeDetectorRef, forwardRef, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS,
  FormGroup,
  FormControl,
  Validator,
  Validators,
  AbstractControl,
  ValidationErrors
} from '@angular/forms';
import {errors} from './email-errors';
import {FormfieldbaseComponent, setTimeoutPromise} from '../formfieldbase/formfieldbase.component';

// many users put .con instead .com so we validate this entry, Validator.email does not detect a@b as bad email address
function wrongDomainValidate(control: AbstractControl): { [key: string]: boolean } | null {
  if (control.value !== undefined && control.value !== '' && (control.value.toLowerCase().includes('.con') || !control.value.toLowerCase().includes('.')) ) {
      return { 'wrongDomainValidate': true };
  }
  return null;
}

@Component({
  selector: 'app-email-field',
  templateUrl: './email-field.component.html',
  styleUrls: ['../formfieldbase/formfieldbase.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EmailFieldComponent),
      multi: true
    },
    {
     provide: NG_VALIDATORS,
     useExisting: forwardRef(() => EmailFieldComponent),
     multi: true
   }
 ]
})
export class EmailFieldComponent extends FormfieldbaseComponent implements OnChanges, ControlValueAccessor, Validator   {

  @ViewChild('em', { static: false, read: ElementRef }) em: ElementRef;
  @ViewChild('em', {static: false}) emailInput: { setFocus: () => void; } ;
  @Input() placeholder: string;

  constructor(private cdRef: ChangeDetectorRef, private elementRef: ElementRef) {
    super('email');
    this.fieldForm = new FormGroup(
      {
        email: new FormControl('',
        [ Validators.minLength(3),
          Validators.maxLength(254),
        ]),
      });
      this.fieldForm.get(this.thisFieldName).setValue('');
   }

  registerOnChange(fn: any): void {
    this.fieldForm.valueChanges.subscribe((fnx) => {
      if (!this.fieldForm.valid) {
        if (this.fieldForm.controls.email && this.fieldForm.controls[this.thisFieldName].hasError('required')) {
          this.errorMessage = errors.required;
        }
        if (this.fieldForm.controls.email && this.fieldForm.controls[this.thisFieldName].hasError('minlength')) {
          this.errorMessage = errors.minLength;
        }
        if (this.fieldForm.controls.email && this.fieldForm.controls[this.thisFieldName].hasError('maxlength')) {
          this.errorMessage = errors.maxLength;
        }
        if (this.fieldForm.controls.email && this.fieldForm.controls[this.thisFieldName].hasError(this.thisFieldName)) {
          this.errorMessage = errors.invalid;
        }
        if (this.fieldForm.controls.email && this.fieldForm.controls[this.thisFieldName].hasError('wrongDomainValidate')) {
          this.errorMessage = errors.invalid;
        }
      } else {
        this.errorMessage = '';
      }
      if (this.errorMessage === '') {
        this.valueChange.emit(fnx.email);
      } else {
        this.valueChange.emit('');
      }
    });
  }

  validate(c: AbstractControl): ValidationErrors | null {
    return this.fieldForm.valid ? null : { invalidForm: {valid: false, message: this.errorMessage}};
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.minValue  && changes.hasOwnProperty('minValue') && changes.minValue.isFirstChange() ) {
      if (parseInt(this.minValue, 10) > 0) { // value must be greater than zero always
        this.minLen = parseInt(this.minValue, 10); // override with custom min
      } else {
        this.minLen = 3;
      }
      if (this.maxLen > this.minLen && this.requiredField) {
        this.fieldForm.get(this.thisFieldName).setValidators([
          Validators.required,
          Validators.minLength(this.minLen), // override constructor
          Validators.maxLength(this.maxLen),
          Validators.email,
          wrongDomainValidate
        ]);
      } else if (this.maxLen > this.minLen && !this.requiredField) {
        this.fieldForm.get(this.thisFieldName).setValidators([
          Validators.minLength(this.minLen), // override constructor
          Validators.maxLength(this.maxLen),
          Validators.email,
          wrongDomainValidate
        ]);
      }
    }
    if (this.maxValue  && changes.hasOwnProperty('maxValue') && changes.maxValue.isFirstChange() ) {
      if (parseInt(this.maxValue, 10) > 0) { // value must be greater than zero always
        this.maxLen = parseInt(this.maxValue, 10); // override with custom max
      } else {
        this.maxLen = 254;
      }
      if (parseInt(this.maxValue, 10) > this.minLen && this.requiredField) {
        this.fieldForm.get(this.thisFieldName).setValidators([
          Validators.required,
          Validators.minLength(this.minLen),
          Validators.maxLength(this.maxLen), // override constructor
          Validators.email,
          wrongDomainValidate
        ]);
      } else if (parseInt(this.maxValue, 10) > this.minLen && !this.requiredField) {
        this.fieldForm.get(this.thisFieldName).setValidators([
          Validators.minLength(this.minLen),
          Validators.maxLength(this.maxLen), // override constructor
          Validators.email,
          wrongDomainValidate
        ]);
      }
    }
    if (this.getVal && changes.getVal.firstChange !== null && changes.getVal.firstChange !== undefined && this.getVal !== '' ) {
      this.fieldForm.get(this.thisFieldName).setValue(this.getVal);
    } else if (changes.getVal.isFirstChange() && (this.getVal === '' || !this.getVal) ) {
      this.setValue('');
    }
    if (this.getVal && this.getVal !== '') {
      if (parseFloat(changes.getVal.previousValue) !== parseFloat(changes.getVal.currentValue)) {
        this.fieldForm.get(this.thisFieldName).setValue(changes.getVal.currentValue);
      }
    }
  }

}
